<template>
    <div class="home">
        <div class="nav">
            <div class="nav-menu">
                <img class="logo" src="@/assets/img/logo.png" alt="">
                <div class="menu-item active">
                    <router-link to="/plugin/plugin">应用购买</router-link>
                    <div class="bottom"></div>
                </div>
                <div class="menu-item">
                    <router-link to="/dashboard">管理中心</router-link>
                    <div class="bottom"></div>
                </div>
                <div class="login-status">
                    <div v-if="user.mobile > 0">{{user.mobile}}</div>
                    <router-link to="/passport/login" v-else>登录</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .logo{
        margin-top: 18px;
        margin-right: 20px;
        float: left;
        height: 24px;
        width: 114px;
    }

    .nav{
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        color: #fff;
        background-color: #252D3F;
    }

    .nav-menu{
        width: 1200px;
        margin: 0 auto;
    }

    .menu-item.active a{
        color: #2E9FFF;
    }

    .active .bottom{
        height: 4px;
        width: 20px;
        border-radius: 2px;
        background-color: #2E9FFF;
        margin: -4px auto 0;
    }

    .menu-item{
        float: left;
        margin-left: 80px;
    }

    .login-status{
        float: right;
    }
</style>

<script>
// @ is an alias to /src
export default {
    name: 'home',
    components: {
    },
    data() {
        return {
            user: {mobile: null},
            loading: false
        }
    },
    created() {
        this.$router.push('plugin/plugin')
        // this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            this.$store.dispatch('getUser').then(e => {
                this.loading = false
                this.user = e
            })
        }
    }
}
</script>
